import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SelectInput.css'; // eslint-disable-line css-modules/no-unused-class

const DEFAULT_SELECT_VALUE = 'default';
const stringOrNumberPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

class SelectInput extends React.Component {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        val: stringOrNumberPropType,
        title: PropTypes.string,
      }),
    ),
    onChange: PropTypes.func,
    value: stringOrNumberPropType,
    name: stringOrNumberPropType,
    disabled: PropTypes.bool,
    titleKey: PropTypes.string,
  };
  static defaultProps = {
    options: [],
    onChange: () => {},
    value: null,
    name: null,
    disabled: false,
    titleKey: 'title',
  };

  handleSelectChange = e => {
    const { onChange, name, options } = this.props;
    const selectedOption = options[e.target.selectedIndex];

    onChange(name, selectedOption);
  };

  render() {
    const { options, value, disabled, titleKey } = this.props;
    const selected = options.find(option => option.val === value);

    return (
      <div className={s.root}>
        <div className={s.selectContainer}>
          <div className={s.hint}>
            {(selected && (selected[titleKey] || selected.title)) || ''}
            <i className="fa fa-angle-down" />
          </div>

          <select
            disabled={disabled}
            className={s.select}
            onChange={this.handleSelectChange}
            value={value || DEFAULT_SELECT_VALUE}
          >
            {options.map(item =>
              <option key={item.val + item.title} value={item.val || DEFAULT_SELECT_VALUE}>
                {item[titleKey] || item.title}
              </option>,
            )}
          </select>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(SelectInput);



// WEBPACK FOOTER //
// ./src/shared/components/UI/NumberInputWithSelect/SelectInput/SelectInput.js